export const staffDashboard = {
  title: '员工门户',
  subtitle: '员工门户',
  settings: '设置',
  
  // 快捷操作
  quickActions: '快捷操作',
  scanForCheckout: '扫码结账',
  menuItems: '菜单项目',
  editCustomer: '编辑顾客',
  scanReceipt: '扫描收据',
  viewTransactions: '查看交易',
  
  // 顾客验证
  customerVerified: '顾客已验证',
  welcomeBack: '欢迎回来',
  firstVisit: '首次光临！',
  birthdayBonus: '生日奖励！',
  continueToCheckout: '继续结账',
  
  // 结账
  checkout: '结账',
  billAmount: '账单金额',
  enterBillAmount: '输入账单金额',
  billAmountPlaceholder: '0.00',
  availableBalance: '可用余额',
  redeemAmount: '兑换金额',
  enterRedeemAmount: '输入兑换金额',
  redeemAmountPlaceholder: '0.00',
  maxRedeemable: '最多可兑换',
  summary: '摘要',
  originalAmount: '原始金额',
  discount: '折扣 (5%)',
  vcRedeemed: '已兑换 VC',
  finalAmount: '最终金额',
  processCheckout: '处理结账',
  processing: '处理中...',
  
  // 交易成功
  transactionSuccess: '交易成功！',
  transactionId: '交易编号',
  customer: '顾客',
  vcEarned: '获得 VC',
  birthdayBonusEarned: '生日奖励',
  done: '完成',
  
  // 顾客查找
  lookupCustomer: '查找顾客',
  searchByEmail: '按电子邮件或姓名搜索',
  search: '搜索',
  scanQR: '扫描二维码',
  noCustomerFound: '未找到顾客',
  
  // 编辑顾客
  editCustomerTitle: '编辑顾客',
  fullName: '全名',
  email: '电子邮件',
  birthday: '生日',
  optional: '可选',
  saveChanges: '保存更改',
  saving: '保存中...',
  
  // 二维码扫描器
  scanCustomerQR: '扫描顾客二维码',
  pointCamera: '将相机对准顾客的二维码',
  cancel: '取消',
  
  // 收据 OCR
  scanReceiptTitle: '扫描收据',
  uploadReceipt: '上传收据',
  takePhoto: '拍照',
  processingReceipt: '处理中...',
  extracting: '正在从收据中提取数据...',
  
  // 菜单管理
  menuManagement: '菜单管理',
  items: '项',
  available: '可用',
  import: '导入',
  export: '导出',
  add: '添加',
  totalItems: '总项目数',
  availableItems: '可用',
  lowStock: '库存不足',
  categories: '类别',
  searchPlaceholder: '按名称或类别搜索...',
  allItems: '所有项目',
  meatPoultry: '肉类与家禽',
  seafood: '海鲜',
  vegetables: '蔬菜',
  processed: '加工食品',
  noodlesRice: '面条与米饭',
  herbsSpices: '香草与香料',
  others: '其他',
  bulkActions: '批量操作',
  selected: '已选',
  delete: '删除',
  toggleAvailability: '切换可用性',
  sortBy: '排序方式',
  name: '名称',
  price: '价格',
  stock: '库存',
  category: '类别',
  viewMode: '视图',
  list: '列表',
  grid: '网格',
  noItems: '未找到菜单项目',
  noItemsDesc: '从添加第一个菜单项目或从 CSV 导入开始',
  
  // 菜单项目表单
  addMenuItem: '添加菜单项目',
  editMenuItem: '编辑菜单项目',
  itemName: '项目名称',
  required: '必填',
  itemNamePlaceholder: '例如：鸡胸肉、老虎虾',
  itemNameHint: '使用与收据上显示的名称相同，以便更好地进行 OCR 匹配',
  priceRM: '价格 (RM)',
  unit: '单位',
  unitPlaceholder: 'Kg、包、盒',
  nutritionalInfo: '营养信息 (每100克)',
  calories: '卡路里',
  protein: '蛋白质 (克)',
  fat: '脂肪 (克)',
  inventory: '库存',
  stockQuantity: '库存数量',
  lowStockAlert: '低库存警报',
  availableForSale: '可供销售',
  toggleUnavailable: '切换以标记项目为不可用',
  notes: '备注',
  notesPlaceholder: '附加备注或描述...',
  addItem: '添加项目',
  updateItem: '更新项目',
  
  // 菜单项目导入
  importMenuItems: '导入菜单项目',
  howToImport: '如何导入',
  importStep1: '下载下面的 CSV 模板（包含格式说明和示例）',
  importStep2: '填写您的菜单项目 - 名称和类别为必填项',
  importStep3: '保留说明行（以 # 开头）以供参考 - 导入时将被忽略',
  importStep4: '上传完成的 CSV 文件',
  importStep5: '查看任何验证错误并修复它们',
  importStep6: '点击导入以将项目添加到您的菜单',
  csvFormatPreview: 'CSV 格式预览：',
  formatLine1: '第一行：列标题（必需）',
  formatLine2: '第二行：说明（可选，将被跳过）',
  formatLine3: '后续行：您的菜单项目',
  downloadTemplate: '下载 CSV 模板',
  uploadCSV: '上传 CSV 文件',
  clickToUpload: '点击上传 CSV 文件',
  maxFileSize: '最大文件大小：5MB',
  validationErrors: '验证错误',
  importComplete: '导入完成',
  successfullyImported: '成功导入',
  failed: '失败',
  totalProcessed: '总处理数',
  validCategories: '有效类别：',
  importItems: '导入项目',
  
  // 交易页面
  transactions: '交易',
  transaction: '笔交易',
  period: '时期',
  oneDay: '1 天',
  sevenDays: '7 天',
  thirtyDays: '30 天',
  all: '全部',
  date: '日期',
  amount: '金额',
  noTransactions: '所选时期内未找到交易',
  totalAmount: '总金额',
  
  // 设置
  profile: '个人资料',
  memberSince: '会员自',
  preferences: '偏好设置',
  language: '语言',
  notifications: '通知',
  about: '关于',
  privacyPolicy: '隐私政策',
  termsOfService: '服务条款',
  appVersion: '应用版本',
  logout: '登出',
  
  // 提示消息
  customerNotFound: '未找到顾客。请检查二维码并重试。',
  transactionFailed: '处理交易失败',
  customerUpdated: '顾客详情更新成功！',
  receiptScanned: '收据已扫描！',
  itemsMatched: '项已匹配',
  confidence: '置信度',
  
  ocr: {
    linkSuccess: '收据已关联到 {customer} 的交易！(相差 {timeDiff}) | {items} 项 | 置信度: {confidence}%',
    scanSuccess: '收据已扫描！金额: RM {amount}{itemsText} | 置信度: {confidence}% | ⚠️ 未找到匹配交易 - 请先创建交易',
    linkError: '收据已扫描但关联失败: {error}',
    refreshError: '刷新客户数据失败',
  },

  noItemsToExport: '没有可导出的项目',
  exportedItems: '已导出',
  exportFailed: '导出项目失败。请重试。',
  menuItemAdded: '菜单项目添加成功',
  menuItemUpdated: '菜单项目更新成功',
  failedToSave: '保存项目失败',
  
  // 错误消息
  error: '错误',
  tryAgain: '请重试',
  loadingError: '加载数据失败',
  noRestaurant: '您的账户未分配餐厅',
  
  // 交易详情表
  detailSheetTitle: '交易详情',
  detailCustomer: '顾客',
  detailBreakdown: '明细',
  detailReceiptItems: '收据项目',
  detailNoItems: '未提取项目',
  detailFirstVisit: '首次光临',
  detailReceiptScanned: '收据已扫描',
  detailVoided: '已作废',
  voidTransaction: '作废交易',
  voidReason: '作废原因',
  voidReasonPlaceholder: '例如：输入金额错误',
  confirmVoid: '确认作废',
  cancelVoid: '取消',
  voidConfirmTitle: '确认作废交易？',
  voidConfirmDesc: '此操作无法撤销。交易金额将从收入中扣除，VC 将被收回。',
  voidSuccess: '交易已成功作废',
};
